export class VersionService {
  appVersion = '2.3.71'; // TODO update this on every release
  country =
    (window.location.hostname === 'chile.fitpass.app' || window.location.hostname === 'staging.chile.fitpass.app')
      ? 'CL'
      : (window.location.hostname === 'peru.fitpass.app' || window.location.hostname === 'staging.peru.fitpass.app')
        ? 'PE'
        : (window.location.hostname === 'colombia.fitpass.app' || window.location.hostname === 'staging.colombia.fitpass.app')
          ? 'CO'
          : 'MX';
}



// WEBPACK FOOTER //
// ./src/services/version.ts